module.exports = __webpack_public_path__ + "static/media/science_submission.3cc78957.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/science_submission.gif
// module id = 1143
// module chunks = 0